export default __webpack_public_path__ + "static/media/Helm of the Huntmaster.1c1f83ac.jpg";